import React, { useContext, useState } from 'react';
import proptypes from 'prop-types';
const { func, string, number, bool } = proptypes;
import { IconButton, Menu, MenuItem } from '@one-thd/sui-atomic-components';
import { More, Document, TrashCan, Duplicate } from '@one-thd/sui-icons';
import { ProductListContext } from '../ProductListContext';

export const MoreMenu = ({
  onAddNote,
  iconSize,
  hasNote,
  itemId,
  intentId,
  intent,
  groupId,
  quantity,
  itemOrder,
  isIntentPod,
  isHiddenProduct
}) => {
  const {
    removeListItems,
    removeIntentItem,
    duplicateIntent,
    isSharedList,
    isRemoving
  } = useContext(ProductListContext);
  const [anchorEl, setAnchorEl] = useState(null);
  const [openMenu, setOpenMenu] = useState(false);

  // Determine if Duplicate should be disabled
  // Disabled when: no intent/searchKeyword OR hidden product OR shared list
  const canDuplicate = Boolean(intent) && !isHiddenProduct && !isSharedList;

  const handleOpenMenu = (event) => {
    setAnchorEl(event.currentTarget);
    setOpenMenu(true);
  };

  const handleCloseMenu = () => {
    setAnchorEl(null);
    setOpenMenu(false);
  };

  const handleAddNote = () => {
    onAddNote();
    handleCloseMenu();
  };

  const handleRemoveItem = () => {
    if (!isRemoving) {
      if (isIntentPod && intentId) {
        // For intent pods, use removeIntentItem
        removeIntentItem({ groupId, intentId });
      } else {
        // For regular product pods, use removeListItems
        removeListItems([itemId]);
      }
    }
    handleCloseMenu();
  };

  const handleDuplicate = () => {
    if (!canDuplicate) return;

    duplicateIntent({
      groupId,
      intent,
      quantity: quantity || 1,
      itemOrder: itemOrder || 1,
      sourceIntentId: intentId,
      sourceItemId: itemId
    });
    handleCloseMenu();
  };

  return (
    <>
      <IconButton
        icon={More}
        iconSize={iconSize}
        aria-label="More options"
        onClick={handleOpenMenu}
        data-testid="more-menu-button"
      />
      <Menu
        anchorEl={anchorEl}
        open={openMenu}
        onClose={handleCloseMenu}
        data-testid="more-menu"
        placement="bottom-end"
      >
        <MenuItem onClick={handleAddNote} data-testid="add-note-menu-item" disabled={isIntentPod}>
          <Document size="small" />
          <span style={{ marginLeft: '8px' }}>{hasNote ? 'Edit Note' : 'Add Note'}</span>
        </MenuItem>
        <MenuItem
          onClick={handleDuplicate}
          disabled={!canDuplicate}
          data-testid="duplicate-menu-item"
        >
          <Duplicate size="small" />
          <span style={{ marginLeft: '8px' }}>Duplicate</span>
        </MenuItem>
        <MenuItem onClick={handleRemoveItem} data-testid="remove-item-menu-item" disabled={isRemoving}>
          <TrashCan size="small" />
          <span style={{ marginLeft: '8px' }}>Remove Item</span>
        </MenuItem>
      </Menu>
    </>
  );
};

MoreMenu.propTypes = {
  onAddNote: func,
  iconSize: string,
  hasNote: bool,
  itemId: string,
  intentId: string,
  intent: string,
  groupId: string,
  quantity: number,
  itemOrder: number,
  isIntentPod: bool,
  isHiddenProduct: bool
};

MoreMenu.defaultProps = {
  onAddNote: () => {},
  iconSize: 'small',
  hasNote: false,
  itemId: null,
  intentId: null,
  intent: null,
  groupId: null,
  quantity: 1,
  itemOrder: 1,
  isIntentPod: false,
  isHiddenProduct: false
};
